<template>
  <v-card>
    <v-progress-linear color="primary" :indeterminate="loading" height="3" />

    <v-card-title primary-title>
      <div class="headline">Complaints</div>
    </v-card-title>

    <v-card-text>
      <v-btn>Raise Complaint</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false
    };
  }
};
</script>
